import { QueryFactory } from "../../../../Common";
export const QSearch = QueryFactory("Search");
//# sourceMappingURL=QSearch.js.map